<template>
  <div class="login">
    <a-spin :spinning="spinning">
      <div class="body">
        <div class="img"></div>
        <div class="kuang" v-if="num == 0">
          <div class="tit">
            <img src="@/assets/layout/titlelogo.png" alt="" />
            <div class="txt">
              <p>社科普及工作管理平台</p>
            </div>
          </div>

          <div class="tabs">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="账户密码登录" force-render>
                <div style="padding-top: 15px">
                  <a-input v-model="userName" placeholder="请输入单位名称">
                    <a-icon slot="prefix" type="user" style="color: #007651" />
                  </a-input>
                  <div class="interval"></div>
                  <a-input v-model="passWord" type="password" placeholder="请输入密码">
                    <a-icon slot="prefix" type="lock" style="color: #007651" />
                  </a-input>
                  <div class="interval"></div>
                  <div class="choose">
                    <!-- <a-checkbox :checked="checked" @change="onChange">记住密码</a-checkbox> -->
                    <p style="color: #007651" @click="registerClick">
                      我要注册
                    </p>
                    <span>|</span>
                    <p style="color: #007651" @click="forgetClick">忘记密码</p>
                  </div>
                  <div class="interval"></div>
                  <button class="loginbtn" @click="login">进入系统</button>
                  <p class="tips1">技术支持电话：025-58682026（工作日9:00-11:30，14:00-17:30）</p>
                  <p class="tips2">技术支持qq群：661710845</p>
                </div>
              </a-tab-pane>
              <!--                  <a-tab-pane key="2" tab="扫码登陆" force-render>-->
              <!--                    <div style="padding-top:15px; display: none">-->
              <!--                      <a-input v-model="userName" placeholder="请输入手机号">-->
              <!--                        <a-icon slot="prefix" type="user" />-->
              <!--                      </a-input>-->
              <!--                      <div class="interval"></div>-->
              <!--                      <a-input v-model="passWord" placeholder="请输入密码">-->
              <!--                        <a-icon slot="prefix" type="lock" />-->
              <!--                      </a-input>-->
              <!--                      <div class="interval"></div>-->
              <!--                      <div class="choose">-->
              <!--                        <a-checkbox :checked="checked" @change="onChange">记住密码</a-checkbox>-->
              <!--                        <p>忘记密码</p>-->
              <!--                      </div>-->
              <!--                      <div class="interval"></div>-->
              <!--                      <button class="loginbtn" @click="login">进入系统</button>-->
              <!--                    </div>-->
              <!--                  </a-tab-pane>-->

            </a-tabs>
            <div class="remove-cache">
              <a-popconfirm title="执行当前操作会清除浏览器缓存，确认执行吗?" ok-text="是" cancel-text="否" @confirm="removeCache()">
                <button class="remove-button">清除缓存</button>
              </a-popconfirm>
            </div>
          </div>
        </div>

        <div v-if="num == 1">
          <Register @goLogin="goLogin" @forget="forget" @backLogin="backLogin" />
        </div>
        <div v-if="num == 2">
          <ForgetPassword @goLogin="goLogin" @registerClick="registerClick" @backLogin="backLogin" />
        </div>
        <div v-if="num == 3">
          <CompleteInformation @goLogin="goLogin" />
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { decUserLoginApi } from "@/api/declare.js";
import getMD5 from "@/plugins/getMD5";
import { mapGetters, mapActions } from "vuex";
import { validatePassword } from "@/plugins/validate";
import Register from "@/components/register/index.vue";
import ForgetPassword from "@/components/forget-password/index.vue";
import CompleteInformation from "@/components/complete-information/index.vue";
export default {
  components: { Register, ForgetPassword, CompleteInformation },
  data() {
    return {
      userName: "",
      passWord: "",
      checked: true,
      spinning: false,
      num: 0 /* 0为登录首页，1为注册页面，2为忘记密码页面  3为补全信息页面*/,
    };
  },
  methods: {
    forgetClick() {
      this.num = 2;
    },
    backLogin(val) {
      this.num = val;
    },
    //切换登入页
    goLogin() {
      this.num = 0;
    },
    //注册
    registerClick() {
      this.num = 1;
    },
    //忘记密码
    forget() {
      this.num = 2;
    },
    //配置令牌
    ...mapActions(["setToken"]),
    login() {
      sessionStorage.removeItem("modifyInformation");
      // this.num = 3;
      // return
      if (this.userName == "") {
        this.$message.warning("用户名不能为空！");
        return false;
      }
      if (this.passWord == "") {
        this.$message.warning("密码不能为空！");
        this.checked = false;
        return false;
      }
      // if (!validatePassword(this.passWord.trim())) {
      //   this.$message.warning(
      //     "您的账号不是强密码，请前往新华日报健康客户端进行修改。密码要求：强制大写字母+小写字母+数字+特殊字符，8位以上！"
      //   );
      //   return false;
      // }
      let mdpass = "";
      getMD5(this.passWord.trim(), function (md5) {
        mdpass = md5;
      });

      this.spinning = true;

      this.userLogin({
        userName: this.userName,
        // password: this.passWord,
        password: mdpass,
      });

      // this.$router.push({
      //     path: '/ugc/workbench'
      // }).catch(e => { })
    },
    onChange(e) {
      this.checked = e.target.checked;
      console.log(this.checked);
    },
    //账号密码登陆
    userLogin(val = {}) {
      // let res = await productUserLogin({...val})
      decUserLoginApi({ ...val })
        .then((res) => {
          if (res && res.status) {
            if (this.checked) {
              let mdpass = "";
              getMD5(this.passWord.trim(), function (md5) {
                mdpass = md5;
              });
              localStorage.setItem(
                "loginInfo",
                JSON.stringify({ user: this.userName.trim(), psw: mdpass })
              );
            } else {
              localStorage.removeItem("loginInfo");
            }

            setTimeout(() => {
              this.spinning = false;
              sessionStorage.setItem("token", res.data.userToken)
              sessionStorage.setItem(
                "userModel",
                JSON.stringify(res.data.productUserInfo)
              );
              localStorage.setItem(
                "userModel",
                JSON.stringify(res.data.productUserInfo)
              );
              let obj = JSON.parse(localStorage.getItem("userModel"));
              // 判断是否是专家登录
              if (obj.userType == "expert" && obj.unitName == "") {
                this.num = 3;
                return;
              }
              this.setToken(res.data.userToken);
              if (obj.userType == "declarator") {
                console.log('shenbao1');
                this.$router.push("/skl/declarationCenter/basePublicize");
              } else {
                this.$router.push("/skl/declarationCenter/projectDeclaration");
              }
            }, 1000);
          } else {
            this.spinning = false;
            this.$message.error(res.message || "服务器发生错误");
          }
        })
        .catch(() => {
          this.spinning = false;
          this.$message.error("登录失败!");
        });
    },
    // 强制清除缓存
    removeCache() {
      if (localStorage.getItem('userModel')) {
        localStorage.removeItem('userModel')
      };
      if (localStorage.getItem('loginInfo')) {
        localStorage.removeItem('loginInfo')
      };
      if (localStorage.getItem('loglevel:webpack-dev-server')) {
        localStorage.removeItem('loglevel:webpack-dev-server')
      };
      if (sessionStorage.getItem('userModel')) {
        sessionStorage.removeItem('userModel')
      };
      if (sessionStorage.getItem('token')) {
        sessionStorage.removeItem('token')
      };
      this.$message.success("清除缓存成功，请重新登录");
      setTimeout(() => {
        location.reload();
      }, 1000);
    },
  },
  created() {
    // if(JSON.parse(sessionStorage.getItem("userModel")).userType == "expert") {
    //   this.num=3;
    // }
    // if (sessionStorage.getItem("modifyInformation")) {
    //   this.num = 1;
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
